import * as React from 'react';
import { AuthorSection } from 'shared/components/NewbuildingGallery/components/AuthorSection';
import { GallerySidebarLayout } from 'shared/components/NewbuildingGallery/components/GallerySidebar';
import { AuthorAsideContainer as AuthorAsideContainerNew } from 'shared/containers/AuthorAsideContainerNew';
import { NewbuildingPremiumBuilderInfo } from 'shared/containers/AuthorAsideContainerNew/parts';
import { GalleryContactsContainer } from 'shared/containers/GalleryContacts/GalleryContacts';
import { FavoriteButtonContainer, PriceContainer } from 'shared/containers/NewbuildingGallerySidebar/parts';
import { DescriptionContainer } from 'shared/containers/NewbuildingGallerySidebar/parts/Description/Description';
import { PricePerSquare } from 'shared/containers/NewbuildingGallerySidebar/parts/PricePerSquare';
import { AgencyBrandingAsideCardContainer } from 'shared/containers/agencyBranding/AgencyBrandingAsideCard';

export const GallerySidebarContainer: React.FC = () => {
  return (
    <GallerySidebarLayout
      title={<DescriptionContainer />}
      favoriteButton={<FavoriteButtonContainer />}
      price={<PriceContainer />}
      pricePerSquare={<PricePerSquare />}
      buttons={<GalleryContactsContainer />}
      author={
        <>
          <AuthorAsideContainerNew />
          <AuthorSection>
            <NewbuildingPremiumBuilderInfo />
          </AuthorSection>
          <AuthorSection>
            <AgencyBrandingAsideCardContainer />
          </AuthorSection>
        </>
      }
    />
  );
};
